var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalMessage',{attrs:{"name":"printMethodModal","title":"Select Print Method","description":"Choose which print method to use.","showClose":true,"size":"small","buttons":[
    {
      text: 'Legacy Method',
      classList: ['bg-gray-100 text-gray-600 border-gray-300'],
      click: () => _vm.selectMethod('old')
    },
    {
      text: 'New Method',
      classList: ['bg-atlas-blue text-white'],
      click: () => _vm.selectMethod('new')
    }
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }